/**
 * Feature flags for experiments and controlled rollouts
 */

/**
 * Debug flag - set to true for verbose logging
 * @type {boolean}
 */
export const DEBUG = false;

/**
 * Check if auto-advance is enabled via URL param or localStorage
 * @returns {boolean} True if auto-advance is enabled
 * @private
 */
function getAutoAdvanceEnabled() {
  // Check URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('aa') === '1') {
    return true;
  }
  
  // Check localStorage flag
  try {
    return localStorage.getItem('listenUpAA') === '1';
  } catch (e) {
    // localStorage might not be available
    return false;
  }
}

/**
 * Auto-advance experiment flag (OFF by default)
 * Enable with ?aa=1 URL param or localStorage listenUpAA=1
 * @type {boolean}
 */
export const AUTO_ADVANCE_ENABLED = getAutoAdvanceEnabled();

/**
 * App Flags - Feature flags for experiments and controlled rollouts
 * @type {Object}
 * @property {boolean} enableContinuitySlot - Include series continuity clip in daily set
 * @property {boolean} feedbackButtons - Show Too Easy / Too Hard buttons
 * @property {boolean} replayInstrumentation - Enable replay_action event logging
 * @property {boolean} showDailySetProgress - Show progress bar in daily set card
 * @property {boolean} enableOnboardingFlow - Show onboarding modal on first run
 * @property {boolean} dailySetPersistsByDate - Persist daily set per date+level
 * @property {boolean} showCompletionCheckmarks - Show checkmarks for completed clips
 */
export const appFlags = {
  enableContinuitySlot: true,     // Include series continuity clip in daily set (Decision #10C)
  feedbackButtons: true,          // Show Too Easy / Too Hard buttons (Decision #25A)
  replayInstrumentation: true,    // Enable replay_action event logging (Decision #29C)
  showDailySetProgress: true,     // Show progress bar in daily set card
  enableOnboardingFlow: true,     // Show onboarding modal on first run
  dailySetPersistsByDate: true,   // Persist daily set per date+level
  showCompletionCheckmarks: true  // Show checkmarks for completed clips
};
